import useEditableCell from "@/react/components/table/useEditableCell";
import { cellErrors } from "@/react/components/table/useTableMutations";
import Input from "@8x8/oxygen-input";
import React from "react";
import schema, {
  thirdPartyMap,
} from "@/react/features/vcc/sms-channels/schema";
import { isColumnSetter } from "@/react/components/table/columns";
import { ValidationWrapper } from "@/react/components/table/components";

export const WavecellStringCell = (cell) => {
  const cellIsColumnSetter = isColumnSetter(cell);
  const { value, onChange, onBlur } = useEditableCell(cell);
  const errors = cellErrors(cell);

  const thirdPartyCell = cell.row
    ?.getAllCells()
    .find((c) => c.column.id === schema.fields.thirdParty.spec.key)
    ?.getContext();

  const isWavecellThirdParty =
    thirdPartyCell?.getValue() === thirdPartyMap.WAVECELL || cellIsColumnSetter;

  return (
    <ValidationWrapper errors={errors}>
      <Input
        size={"small"}
        type="text"
        isDisabled={!isWavecellThirdParty}
        hasError={errors?.length > 0}
        placeholder={`Type value...`}
        value={isWavecellThirdParty ? String(value || "") : "Not applicable"}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
      />
    </ValidationWrapper>
  );
};
